import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import GroupsIcon from '@mui/icons-material/Groups';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import { isFeatureEnabled } from '../../config/featureFlags';
import BusDemandPage from './busDemand/pages/BusDemandPage';
import VisaDemandPage from './visaDemand/pages/VisaDemandPage';
import GroupTicketDemandPage from './groupTicketDemand/pages/GroupTicketDemandPage';

/**
 * TALEPLER (Demands) module — BusDemand / VisaDemand / GroupTicketDemand — migration guide
 * Bölüm 3.3, 3.9 & 5.3. Gated behind the `HasKurumsal` feature flag, matching the legacy
 * app's Kurumsal-only "Talepler" menu section.
 */
export const demandsModule: ModuleDefinition = {
  routes: [
    { path: 'demands/bus', element: <BusDemandPage /> },
    { path: 'demands/visa', element: <VisaDemandPage /> },
    { path: 'demands/group-ticket', element: <GroupTicketDemandPage /> },
  ],
  menuItems: [
    {
      label: 'Otobüs Bileti',
      path: 'demands/bus',
      icon: <DirectionsBusIcon />,
      group: 'Talepler',
      groupIcon: <AssignmentOutlinedIcon />,
      isVisible: () => isFeatureEnabled('HasKurumsal'),
    },
    {
      label: 'Vize',
      path: 'demands/visa',
      icon: <FlightTakeoffIcon />,
      group: 'Talepler',
      isVisible: () => isFeatureEnabled('HasKurumsal'),
    },
    {
      label: 'Grup Bileti',
      path: 'demands/group-ticket',
      icon: <GroupsIcon />,
      group: 'Talepler',
      isVisible: () => isFeatureEnabled('HasKurumsal'),
    },
  ],
};
